/**
 * Zone fork registry — must be imported immediately after zone.js and before
 * any Angular application bootstraps.
 *
 * Patches `Zone.prototype.fork` to record every zone forked with the name
 * "angular".  The set is exposed on `globalThis.__angularZones` so that
 * ctl-common's `safe-element-registry` can validate whether a captured
 * `Zone.current` is a real Angular zone (and not `Zone.root`).
 */
(() => {
  const Z = (globalThis as any).Zone;
  if (!Z?.prototype?.fork) {
    return;
  }

  const angularZones = new Set<any>();
  const originalFork = Z.prototype.fork;

  Z.prototype.fork = function (zoneSpec: any) {
    const forked = originalFork.call(this, zoneSpec);
    if (zoneSpec?.name === 'angular') {
      angularZones.add(forked);
    }
    return forked;
  };

  (globalThis as any).__angularZones = angularZones;
})();
